import { render, staticRenderFns } from "./RedeList.vue?vue&type=template&id=5932a89c&scoped=true"
import script from "./RedeList.vue?vue&type=script&lang=js"
export * from "./RedeList.vue?vue&type=script&lang=js"
import style0 from "./RedeList.vue?vue&type=style&index=0&id=5932a89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932a89c",
  null
  
)

export default component.exports